import classNames from "classnames";
import { omit } from "lodash";
import React from "react";

import "./ACLink.less";

interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  primary?: boolean;
  overlay?: boolean;
  disabled?: boolean;
}

const ACLink = React.forwardRef<HTMLAnchorElement, LinkProps>(function ACLink(
  { primary = true, overlay = false, disabled = false, className, ...props },
  ref,
) {
  return (
    <a
      className={classNames(
        "ac-link",
        {
          "ac-link-primary": primary,
          "ac-link-overlay": overlay,
          "ac-link-disabled": disabled,
          clickable: !disabled,
        },
        className,
      )}
      ref={ref}
      rel="noopener noreferrer"
      {...omit(props, disabled ? ["href", "onClick"] : "")}
    >
      {props.children}
    </a>
  );
});

export default ACLink;
